import { render, staticRenderFns } from "./HotelPricePlan.vue?vue&type=template&id=6dcabcbb&scoped=true"
import script from "./HotelPricePlan.vue?vue&type=script&lang=js"
export * from "./HotelPricePlan.vue?vue&type=script&lang=js"
import style0 from "./HotelPricePlan.vue?vue&type=style&index=0&id=6dcabcbb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcabcbb",
  null
  
)

export default component.exports